// Voice OTP page: the hero and intro copy (built-in defaults, editable in the portal under Website Content).
export const VOICE_OTP = {
  hero: {
    title: 'Verify users with a',
    highlight: 'missed call',
    sub: 'Flash calls replace SMS one-time passwords. The caller ID is the code, so there is nothing to answer.',
  },
  intro: {
    title: 'The same verification, without the SMS bill',
    body: 'A flash call is a short call to the user’s mobile that is never meant to be answered. Nothing changes on the handset and nothing new is installed.',
  },
};
